<ng-container *transloco="let t">
    <div class="relative">
        <tui-svg *ngIf="options.length > 1 && !isHiddenIconLeft" src="tuiIconChevronRightLarge" class="icon-mobile-right"></tui-svg>
        <div class="w-full 
            overflow-x-auto md:overflow-x-visible 
            scroll-smooth 
            grid grid-flow-col auto-cols-[200px] 
            lg:grid-flow-row lg:auto-cols-auto 
            lg:grid-cols-2 2xl:grid-cols-3 gap-2 
            mb-6 md:mb-2
            mt-6 md:mt-0
            payment_type"
            (scroll)="onScroll($event)">
            
            <tui-radio-block
                *ngFor="let item of options"
                [formControl]="paymentTypeCtrl"
                contentAlign="right"
                [size]="size"
                [item]="item"
                [hideRadio]="true"
            >
                <div class="flex items-center flex-col gap-2 content-payment justify-center">
                    <tui-svg [src]="item | paymentTypeIcon" class="icon-custom"></tui-svg>
                    <span class="ml-1.5 break-words whitespace-normal">{{ t(item | paymentTypeLabel : orderType) }}</span>
                    <tui-svg src="icon::check_v2" class="icon-absolute"></tui-svg>
                </div>
            </tui-radio-block>
        </div>
    </div>
    <div
        *ngIf="paymentTypeCtrl.value === PaymentType.BankTransfer && bankTransferInformation() !== null"
        class="mt-2 p-4 text-base bg-blue-50 text-gray-700 rounded block ng-star-inserted"
    >
        {{ bankTransferInformation() }}
    </div>
</ng-container>
